import { ReactNode, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, CardSection, Text } from '@/lib/v2/components';
import { Flex } from '@/lib/v2/components/Layout/Stack';

import { ContactsActionDropdown } from '@/src/ContactsModule/components/ContactsActionDropdown';
import { ContactsTableContainer } from '@/src/ContactsModule/components/ContactsTableContainer/ContactsTableContainer';
import { ContactsIcon } from '@/src/ContactsModule/Icons/ContactsIcon';
import { quantifier } from '@/src/ContactsModule/utils/quantifier';
import { ServiceMethods } from '@/src/infrastructure/Protocol/EmblueService';
import { useEmblue } from '@/src/infrastructure/Protocol/useEmblue';

import { SectionHeader } from '@/modules/ContactsModule/components';
import { CardsFilterDiscarded } from '@/modules/ContactsModule/screens/DiscardedMain/components';

export const DiscardedMain = () => {
  const { t } = useTranslation();
  const [lastRefresh, setLastRefresh] = useState<number>(0);
  const [subtitleCountMessage, setSubtitleCountMessage] = useState<ReactNode>();
  const [totalContactsCount, setTotalContactsCount] = useState<number>();
  const [statusDiscardedCount, , statusDiscardedCountIsLoading] = useEmblue(
    ServiceMethods.getContactDiscardedStatusCount,
    {
      lastRefresh,
    }
  );

  const title = useMemo(() => {
    return (
      <Flex column itemAlignment="start">
        <div className="flex flex-row gap-2">
          <Text as="span" fontWeight="medium" variant="title-1">
            {`${t('CONTACTS_MAIN.contacts')} -`}
          </Text>
          <Text color="primary" fontWeight="medium" variant="title-1">
            {t('CONTACTS_MAIN.all')}
          </Text>
          <Text color="primary" fontWeight="medium" variant="title-1">
            {totalContactsCount && `(${quantifier(totalContactsCount)})`}
          </Text>
        </div>
        {subtitleCountMessage && subtitleCountMessage}
      </Flex>
    );
  }, [subtitleCountMessage, t, totalContactsCount]);

  return (
    <>
      <CardsFilterDiscarded
        statusList={statusDiscardedCount?.list as []}
        titleIsLoading={statusDiscardedCountIsLoading}
      />
      <Card>
        <CardSection noPadding>
          <Flex column>
            <SectionHeader
              actionsButtons={<ContactsActionDropdown />}
              icon={<ContactsIcon />}
              justifyContentActionsButtons="end"
              title={title}
            />
            <div className="h-full w-full">
              <ContactsTableContainer
                isDiscarded={true}
                setContactsCount={setTotalContactsCount}
                setCountMessage={setSubtitleCountMessage}
                setLastRefreshParent={setLastRefresh}
              />
            </div>
          </Flex>
        </CardSection>
      </Card>
    </>
  );
};
